<template>
	<div class="sky-textarea">
		<el-input
			ref="input"
			type="textarea"
			v-bind="$attrs"
			:value="value"
			v-focus="focus"
			@input="handleChange"
		></el-input>
		<div class="tip" v-if="tips">{{ tips }}</div>
	</div>
</template>
<script>
export default {
	name: 'sky-textarea',
	componentName: 'sky-textarea',
	props: ['value', 'focus', 'tips'],
	data() {
		return {};
	},
	methods: {
		search(e) {
			this.$emit('search-click', e);
		},
		handleChange(e) {
			this.$emit('input', e);
		},
	},
	directives: {
		focus: {
			update(el, data) {
				// 重点注意这里 当前元素是div  所以要查到子元素中的input
				const dom = el.querySelector('input') || el.querySelector('textarea');
				if (data.value) dom.focus();
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.sky-textarea {
	.tip {
		margin-top: 5px;
		font-size: 13px;
		color: #e6a23c;
	}
}
</style>
